function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.044,
  cy: 16.71,
  r: 15,
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 10.168,
  y: 10.105,
  fill: "currentColor",
  stroke: "currentColor",
  rx: 0.5
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 18.355,
  y: 10.105,
  fill: "currentColor",
  stroke: "currentColor",
  rx: 0.5
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 10.168,
  y: 18.086,
  fill: "currentColor",
  stroke: "currentColor",
  rx: 0.5
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 18.355,
  y: 18.086,
  fill: "currentColor",
  stroke: "currentColor",
  rx: 0.5
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.855,
  cy: 9.605,
  r: 2.048,
  fill: "#BF3030"
});

function SvgAppstoreBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstoreBlue);
export default __webpack_public_path__ + "static/media/appstore-blue.ff76dc80.svg";
export { ForwardRef as ReactComponent };